<p-dialog
  [visible]="visible"
  [modal]="false"
  [blockScroll]="false"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="false"
  [showHeader]="false"
  [baseZIndex]="2000"
  [focusOnShow]="false"
  [transitionOptions]="restoreWithoutTransition ? '0ms' : '150ms cubic-bezier(0, 0, 0.2, 1)'"
  styleClass="cancel-activity-dialog"
  [maskStyleClass]="closing ? 'delete-dialog-mask delete-dialog-mask--closing' : 'delete-dialog-mask'"
  appendTo="body"
  (visibleChange)="!$event && close()"
  (onHide)="onHidden()"
>
  <div class="delete-dialog-content">
    <div class="delete-dialog-header">
      <h3>{{ 'dialogs.cancelActivityTitle' | translate }}</h3>
      <button type="button" class="delete-dialog-close" (click)="close()">
        <i class="pi pi-times"></i>
      </button>
    </div>

    <p class="delete-dialog-copy">
      {{ 'dialogs.cancelActivityQuestion' | translate }} "<span>{{ activityName }}</span>" ?
    </p>

    <p class="delete-dialog-copy delete-dialog-copy--warning" style="color: #C73F3F !important; font-weight: 600;">
      {{ 'dialogs.cannotBeUndone' | translate }}
    </p>

    <label class="delete-confirm-row">
      <input type="checkbox" [ngModel]="confirmed" (ngModelChange)="onConfirmedChange($event)" />
      <span>{{ 'dialogs.understand' | translate }}</span>
    </label>

    <div class="delete-dialog-actions">
      <button type="button" class="delete-cancel-btn" (click)="close()">
        <span class="button-label-offset">{{ 'dialogs.cancel' | translate }}</span>
      </button>
      <button type="button" class="delete-confirm-btn" [disabled]="!confirmed" (click)="confirm()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16">
          <rect x="3" y="3" width="18" height="18" rx="2"></rect>
          <path d="M16 8l-8 8M8 8l8 8"></path>
        </svg>
        <span class="button-label-offset">{{ 'dialogs.cancelActivityBtn' | translate }}</span>
      </button>
    </div>
  </div>
</p-dialog>
